import {
    Box,
    FormControlLabel,
    Grid,
    Link,
    Radio,
    Theme,
    Typography,
    useMediaQuery,
} from '@material-ui/core';
import clsx from 'clsx';
import {CreateAccountImage, MojeIDLogo} from '../../../assets';
import useStyles from './CreateAccountStyles';
import {Button} from '../../../components';
import {LoginType} from '../LoginPage';
import {Trans, useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../const/i18nNamespaces';

type Props = {
    selected?: boolean;
    onClickAlternativeSignUp: () => void;
    onClickMojeID: () => void;
    onClickMicrosoft: () => void;
};

const CreateAccount = ({
    selected,
    onClickAlternativeSignUp,
    onClickMojeID,
    onClickMicrosoft,
}: Props) => {
    const classes = useStyles();
    const radioWrapperStyle = clsx(classes.radioWrapper, {
        [classes.selectedRadioWrapper]: selected,
    });
    const isDesktop = useMediaQuery<Theme>(theme => theme.breakpoints.up('sm'));
    const {t} = useTranslation(i18nNamespaces.AUTH);

    return (
        <Box m={1}>
            <Box px={isDesktop ? '25px' : '17px'} className={radioWrapperStyle}>
                <FormControlLabel
                    className={classes.formControlWrapper}
                    value={'CREATE_ACCOUNT' as LoginType}
                    control={<Radio className={classes.radio} />}
                    aria-label="Załóż konto"
                    label={
                        <Box className={classes.radioText}>
                            {t('createNewAccount')}
                        </Box>
                    }
                />
            </Box>
            <Box
                mt={0.5}
                p={isDesktop ? 2 : 1}
                className={clsx(classes.optionContent, {
                    [classes.contentBackground]: selected,
                })}
            >
                {selected ? (
                    <>
                        <Typography paragraph>
                            {t('createAccountFirstParagraph')}
                        </Typography>
                        <Typography paragraph>
                            {t('createAccountSecondParagraph')}
                        </Typography>
                        <Box my={3} className={classes.registerButtonsWrapper}>
                            <Box className={classes.mojeIDWrapper}>
                                <img
                                    src={MojeIDLogo}
                                    alt="Moje ID"
                                    className={classes.mojeIDLogo}
                                />
                                <Button
                                    variant={'contained'}
                                    color={'secondary'}
                                    className={classes.signUpButton}
                                    onClick={onClickMojeID}
                                >
                                    <span className="register-by-bank">
                                        {t('registerByTheBank')}
                                    </span>
                                </Button>
                            </Box>
                            <Button
                                onClick={onClickMicrosoft}
                                className={classes.microsoftButton}
                                startIcon={
                                    <img
                                        src={
                                            'https://learn.microsoft.com/en-us/entra/identity-platform/media/howto-add-branding-in-apps/ms-symbollockup_mssymbol_19.svg'
                                        }
                                    />
                                }
                            >
                                {t('registerByMicrosoft')}
                            </Button>
                        </Box>
                        <Typography>
                            <Trans
                                t={t}
                                i18nKey={'createAccountThirdParagraph'}
                                components={[
                                    <Link
                                        key={'0'}
                                        className={classes.link}
                                        onClick={onClickAlternativeSignUp}
                                    />,
                                ]}
                            />
                        </Typography>
                    </>
                ) : (
                    <img
                        src={CreateAccountImage}
                        alt="Utwórz konto"
                        className={classes.createAccountImage}
                    />
                )}
            </Box>
        </Box>
    );
};

export default CreateAccount;
